import { procurementApi, procurementParameterAuditApi } from "@/main/api";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRowModalSide } from "@/main/components/shared/boxGrid/styles";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import { KogTabsComponent } from "@/main/components/shared/tabs/tabs";
import TooltipComponent from "@/main/components/shared/tooltip/tooltipComponent";
import { GetAuditRequest } from "@/main/models/request";
import { GetAuditResponse } from "@/main/models/response";
import { Controls } from "@/main/services/constants/constantsControl";
import { ParameterTypeEnum } from "@/main/services/enum/ParameterTypeEnum";
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from "@/main/services/utils";
import { useVisualIdentityReducer } from "@/main/store/visualIdentity";
import { TableBody, TableCell, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { createStyles, makeStyles, withStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import * as S from "./styles";

interface IModalAuditProps {
	orderNumber: string;
	quoteDateFormatted: string;
	guidProcurement: string;
	gridData?: GetAuditResponse[];
	auditParameters?: GetAuditResponse[];
	isLoadingDataParameterAudit?: boolean;
	isLoadingData?: boolean;
	handleModalAudit: () => void;
}

const StyledTableCell = withStyles(() =>
	createStyles({
		head: {
			color: "#7e7e7e",
			fontWeight: "bold",
		},
		body: {
			fontSize: 14,
			color: "#000",
		},
	}),
)(TableCell);

export function ModalAudit({
	orderNumber,
	quoteDateFormatted,
	gridData,
	auditParameters,
	isLoadingDataParameterAudit,
	isLoadingData,
}: IModalAuditProps) {
	const INTIAL_TAB_DETAILS: number = 0;

	// states

	const useStylesTooltip = makeStyles({
		popperCustom: { marginLeft: 15 },
	});
	const classesTooltip = useStylesTooltip();
	const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
	const headersDetailsPart = [
		getTranslateByKey("information.partnumber"),
		getTranslateByKey("information.partDescription"),
		getTranslateByKey("information.roundchosen"),
		"",
		"",
		"",
		"",
	];

	const headersDetailsSupplier = [
		getTranslateByKey("information.supplier"),
		getTranslateByKey("information.type"),
		getTranslateByKey("information.price"),
		getTranslateByKey("information.deadline"),
		getTranslateByKey("information.adjustedPrice"),
		getTranslateByKey("information.available"),
		getTranslateByKey("information.directAssign"),
	];

	const headerParameters = [
		getTranslateByKey("information.registerInsurerParametersParameter"),
		getTranslateByKey("information.value"),
	];

	const renderDeliveryDeadline = (deliveryDeadline: number) => {
		return `${deliveryDeadline} ${getTranslateByKey("information.workingDays")}`;
	};

	const renderParamValue = (value: string) => {
		switch (value) {
			case "True":
			case "true":
				return <>{getTranslateByKey("information.yes")}</>;
			case "False":
			case "false":
				return <>{getTranslateByKey("information.no")}</>;
			default:
				return value || <>-</>;
		}
	};

	function renderText(text: string | number | undefined, hasTooltip: boolean = false) {
		if (!text) return "-";

		if (hasTooltip) {
			return <S.TooltipText title={text as string}>{text}</S.TooltipText>;
		}
		return <S.TooltipText>{text}</S.TooltipText>;
	}
	const tabPanels = [
		{
			tab: getTranslateByKey("information.details"),
			panel:
				gridData.length > 0 ? (
					<>
						{gridData.map((part: GetAuditResponse, index) => (
							<div key={index}>
								<S.StyledTableContainer>
									<S.StyledTable $sizeCell="medium" $typeGrid="default" aria-label="customized table">
										<TableHead>
											<TableRow>
												{headersDetailsPart &&
													headersDetailsPart.map((header, index) => (
														<StyledTableCell key={index}>{header}</StyledTableCell>
													))}
											</TableRow>
										</TableHead>
										<TableBody>
											<KOGTableRowModalSide
												key={part.partNumber}
												id={`id-searchAudit-tableRow-result-${part.partNumber}`}
												style={{ cursor: "auto" }}
											>
												<TableCell>
													<div style={{ minWidth: 100 }}>{part.partNumber}</div>
												</TableCell>
												<TableCell>
													<div style={{ minWidth: 150 }}>
														<b>{part.partDescription}</b>
													</div>
												</TableCell>
												<TableCell>
													<div style={{ minWidth: 90 }}>{part.roundName}</div>
												</TableCell>
												<TableCell></TableCell>
												<TableCell></TableCell>
											</KOGTableRowModalSide>
										</TableBody>
										<TableHead>
											<TableRow>
												{headersDetailsSupplier &&
													headersDetailsSupplier.map((header, index) => (
														<StyledTableCell key={index}>{header}</StyledTableCell>
													))}
											</TableRow>
										</TableHead>
										{part.itemAnswers.map((supplier) => (
											<React.Fragment key={supplier.companyName}>
												<TableBody
													style={
														supplier.selectedItem
															? {
																	borderStyle: "solid",
																	borderWidth: "0.13rem",
																	borderColor: visualIdentityReducer.colors.pantone2726C,
																}
															: {}
													}
												>
													<KOGTableRowModalSide
														key={supplier.companyName}
														id={`id-searchAudit-tableRow-result-${supplier.companyName}`}
														style={{ cursor: "auto" }}
													>
														<TableCell>
															<TooltipComponent
																title={renderText(supplier.companyName)}
																stylePopper={classesTooltip.popperCustom}
															>
																<div
																	style={{
																		maxWidth: 130,
																		overflow: "hidden",
																		textOverflow: "ellipsis",
																	}}
																>
																	{renderText(supplier.companyName)}
																</div>
															</TooltipComponent>
														</TableCell>
														<TableCell>{supplier.partTypeName}</TableCell>
														<TableCell>{supplier.formatedAnsweredPrice}</TableCell>
														<TableCell>
															<div
																style={{
																	minWidth: 37,
																}}
															>
																{renderDeliveryDeadline(supplier.deliveryDeadline)}
															</div>
														</TableCell>
														<Tooltip
															title={
																<>
																	<Typography color="inherit">
																		{getTranslateByKey("information.messageAdjustedPrice")}
																		{!isNullUndefined(supplier.advantageRate) && supplier.advantageRate > 0 && (
																			<Typography color="inherit">
																				{getTranslateByKey("information.prioritySupplier")}.
																			</Typography>
																		)}
																	</Typography>
																</>
															}
														>
															<TableCell>
																{supplier.formatedAdjustedPrice}
																{!isNullUndefined(supplier.advantageRate) && supplier.advantageRate > 0 && "*"}
															</TableCell>
														</Tooltip>
														<TableCell>{renderParamValue(supplier.available.toString())}</TableCell>
														<TableCell>{renderParamValue(supplier.directAssigned.toString())}</TableCell>
													</KOGTableRowModalSide>
												</TableBody>
											</React.Fragment>
										))}
									</S.StyledTable>
								</S.StyledTableContainer>
								<S.ContainerReason>
									<S.LabelReason>{part.reasonChoiceName}</S.LabelReason>
								</S.ContainerReason>
							</div>
						))}
					</>
				) : (
					<ResultNotFoundComponent styles={{ marginTop: 10 }} />
				),
			isShowControl: true,
		},
		{
			tab: getTranslateByKey("information.registerInsurerParameters"),
			panel:
				auditParameters.length > 0 ? (
					<BoxGrid rowHeaders={headerParameters}>
						{auditParameters.map((param) => (
							<>
								<KOGTableRowModalSide
									key={param.idParameterType}
									id={"id-searchAudit-tableRow-result-" + param.idParameterType}
									style={{ cursor: "auto" }}
								>
									<TableCell width="90%">
										<div style={{ fontWeight: "bold" }}>{param.name}</div>
									</TableCell>
									<TableCell width="10%">
										<div style={{ fontWeight: "bold" }}>{param.value ? param.value : " "}</div>
									</TableCell>
								</KOGTableRowModalSide>
								{param.parameters.map((param) => (
									<KOGTableRowModalSide
										key={param.guid}
										id={"id-searchAudit-tableRow-result-" + param.description}
										style={{ cursor: "auto" }}
									>
										<TableCell width="90%">{param.description}</TableCell>
										<TableCell width="10%">{renderParamValue(param.value)}</TableCell>
									</KOGTableRowModalSide>
								))}
							</>
						))}
					</BoxGrid>
				) : (
					<>
						{isLoadingDataParameterAudit ? (
							<LoadingComponent />
						) : (
							<ResultNotFoundComponent styles={{ marginTop: 10 }} />
						)}
					</>
				),
			isShowControl: isShowControlByElementId(Controls.IdShowAuditParameters),
		},
	];

	return (
		<S.Container>
			<S.ContainerOrderNumber>
				<S.LabelOrderNumber>{getTranslateByKey("information.newOrderNumber")}</S.LabelOrderNumber>
				{orderNumber}
				<S.DetailSpan>
					<S.LabelOrderNumber>{getTranslateByKey("information.quoteDate")}:</S.LabelOrderNumber>
					{quoteDateFormatted || "-"}
				</S.DetailSpan>
			</S.ContainerOrderNumber>
			<S.ContainerTabs>
				{!isLoadingData ? (
					<KogTabsComponent tabPanels={tabPanels} tabCurrent={INTIAL_TAB_DETAILS} customWidth={"50%"} />
				) : (
					<LoadingComponent />
				)}
			</S.ContainerTabs>
		</S.Container>
	);
}
function ModalAuditWithAPI(props: IModalAuditProps) {
	const [auditParameters, setAuditParameters] = useState<GetAuditResponse[]>([]);
	const [gridData, setGridData] = useState<GetAuditResponse[]>([]);
	const [isLoadingData, setIsLoadingData] = useState(false);
	const [isLoadingDataParameterAudit, setIsLoadingDataParameterAudit] = useState(false);

	useEffect(() => {
		setIsLoadingData(true);
		const resquest: GetAuditRequest = {
			guidProcurement: String(props.guidProcurement),
		};
		procurementApi
			.getQuoteAuditData(resquest)
			.then((res) => {
				const dataRes = res.data.result;
				setGridData(dataRes);
			})
			.finally(() => setIsLoadingData(false));

		setIsLoadingDataParameterAudit(true);
		procurementParameterAuditApi
			.getParameterAudit(resquest)
			.then((res) => {
				const dataRes = res.data.result;
				dataRes.forEach((item) => {
					if (item.idParameterType === ParameterTypeEnum.LogisticCost) {
						item.parameters.sort((a, b) => {
							if (a.description < b.description) {
								return -1;
							}
							if (a.description > b.description) {
								return 1;
							}
							return 0;
						});
					}
				});
				setAuditParameters(dataRes);
			})
			.finally(() => setIsLoadingDataParameterAudit(false));
	}, [props.guidProcurement]);
	const customProps: IModalAuditProps = {
		...props,
		gridData,
		auditParameters,
		isLoadingData,
		isLoadingDataParameterAudit,
	};
	return <ModalAudit {...customProps} />;
}
export default ModalAuditWithAPI;
